<template>
    <footer class="footer">
      <p>&copy; <span>{{ currentYear }}</span> My portfolio</p>
    </footer>
</template>
  
<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      currentYear: new Date().getFullYear() 
    };
  }
};
</script>
  
<style scoped>
@import '@/assets/css/style.css';
</style> 